import React from 'react'
import { Grid } from '@material-ui/core'
import { CollectionHeaderRow, CollectionRow } from './CollectionRow'
import {
  ImportCollectionStatus,
  MigrationCollections,
  MigrationStatus,
} from '../../../../types/migration'

interface ShopCollectionsGroupProps {
  migrationCompanyStatus: MigrationStatus
  isCategoryCollectionSelected: boolean
  isPricingTemplateCollectionSelected: boolean
  isNotExportableCollection: boolean
  isImportStatusLoading: boolean
  onCollectionDetailsModalOpen: (collectionName: MigrationCollections) => void
  onCategoryCollectionToggle: () => void
  onPricingTemplateCollectionToggle: () => void
  getImportStatusByCollection: (
    collection: MigrationCollections,
  ) => ImportCollectionStatus | undefined
  onImportDetailsOpen: (collectionName: MigrationCollections) => void
}

export const ShopCollectionsGroup: React.FC<ShopCollectionsGroupProps> = ({
  migrationCompanyStatus,
  isCategoryCollectionSelected,
  isPricingTemplateCollectionSelected,
  isNotExportableCollection,
  onCollectionDetailsModalOpen,
  onCategoryCollectionToggle,
  onPricingTemplateCollectionToggle,
  getImportStatusByCollection,
  onImportDetailsOpen,
  isImportStatusLoading,
}) => {
  const pricingImportStatus = getImportStatusByCollection(MigrationCollections.PricingTemplates)
  const categoryImportStatus = getImportStatusByCollection(MigrationCollections.Categories)

  return (
    <Grid container direction="column" spacing={8}>
      <Grid item>
        <CollectionHeaderRow />
      </Grid>
      <Grid item>
        <CollectionRow
          migrationStatus={migrationCompanyStatus}
          onDetailsModalOpen={onCollectionDetailsModalOpen}
          collectionName={MigrationCollections.PricingTemplates}
          isCollectionSelected={isPricingTemplateCollectionSelected}
          toggleSelected={onPricingTemplateCollectionToggle}
          disabled={isNotExportableCollection}
          importStatus={pricingImportStatus}
          isImportAvailable={Boolean(pricingImportStatus)}
          onImportDetailsOpen={onImportDetailsOpen}
          isImportStatusLoading={isImportStatusLoading}
        />
      </Grid>
      <Grid item>
        <CollectionRow
          migrationStatus={migrationCompanyStatus}
          onDetailsModalOpen={onCollectionDetailsModalOpen}
          collectionName={MigrationCollections.Categories}
          isCollectionSelected={isCategoryCollectionSelected}
          toggleSelected={onCategoryCollectionToggle}
          disabled={isNotExportableCollection}
          importStatus={categoryImportStatus}
          isImportAvailable={Boolean(categoryImportStatus)}
          onImportDetailsOpen={onImportDetailsOpen}
          isImportStatusLoading={isImportStatusLoading}
        />
      </Grid>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/MigrateCompanyProducts/ShopCollectionsGroup.tsx